import React from 'react'
import '../styles/personalInfo.css'

const PersonalInfo = () => {
  return (
    <div id='personalInfo'>
      <h1>Janette King, 36</h1>
      <div id='personal__lines'>
        <span id='personal__lines__thick'></span>
        <span id='personal__lines__thin'></span>
      </div>
      <h2>Fullstack Developer</h2>
    </div>
  )
}

export default PersonalInfo
